import { useEffect, useRef } from "react";

const CITIES: [number, number][] = [
  [77.1, 28.6], [72.8, 19.0], [80.2, 13.0], [77.5, 12.9], [78.4, 17.4],
  [88.3, 22.5], [72.5, 23.0], [75.7, 26.9], [73.8, 15.4], [79.0, 21.1],
  [80.9, 26.8], [85.1, 25.5], [85.8, 20.2], [75.8, 22.7], [76.9, 11.0],
  [74.8, 32.7], [76.6, 8.5], [77.8, 10.9], [78.7, 11.7], [80.0, 15.8],
  [83.2, 17.7], [84.8, 22.1], [87.0, 23.7], [92.7, 26.1], [91.7, 25.6],
  [93.9, 24.8], [94.9, 29.3], [76.0, 30.8], [73.0, 19.9], [70.5, 22.3],
  [72.0, 21.1], [73.7, 18.5], [74.5, 17.0], [76.8, 20.0], [78.0, 18.2],
  [79.5, 12.0], [77.0, 15.8], [82.0, 26.0], [81.0, 16.5], [80.6, 23.2],
  [75.1, 15.4], [74.1, 16.8], [77.3, 28.0], [79.0, 27.2], [82.5, 22.0],
  [86.0, 20.5], [85.3, 23.8], [88.6, 27.3],
];

const HUB_INDICES = new Set([0, 1, 5, 11, 23]);

const ROUTES: [number, number][] = [
  [0, 1], [0, 2], [0, 5], [0, 7], [0, 10], [0, 11], [0, 15], [0, 37],
  [1, 2], [1, 3], [1, 6], [1, 8], [1, 13], [1, 28], [1, 29], [1, 31],
  [2, 3], [2, 4], [2, 8], [2, 14], [2, 35], [2, 36],
  [3, 4], [3, 8], [3, 14], [3, 16], [3, 36],
  [4, 5], [4, 9], [4, 12], [4, 38], [4, 34],
  [5, 11], [5, 12], [5, 22], [5, 23], [5, 47],
  [6, 7], [6, 13], [6, 30], [6, 31], [6, 32],
  [7, 0], [7, 15], [7, 27], [7, 43], [7, 42],
  [8, 9], [8, 36], [8, 39], [8, 3],
  [9, 13], [9, 34], [9, 38], [9, 44],
  [10, 11], [10, 37], [10, 43], [10, 27],
  [11, 5], [11, 22], [11, 46], [11, 47],
  [12, 5], [12, 46], [12, 22], [12, 4],
  [13, 33], [13, 32], [13, 8],
  [14, 16], [14, 18], [14, 2],
  [15, 27], [15, 42], [15, 0],
  [16, 14], [16, 17], [16, 3],
  [17, 18], [17, 14],
  [18, 19], [18, 2],
  [19, 20], [19, 4],
  [20, 21], [20, 12],
  [21, 22], [21, 5],
  [22, 23], [22, 24],
  [23, 24], [23, 25],
  [24, 25], [24, 26],
  [25, 26], [25, 47],
  [26, 15], [26, 47],
  [27, 43], [27, 7],
  [28, 29], [28, 1],
  [29, 30], [29, 6],
  [30, 31], [30, 29],
  [31, 32], [31, 33],
  [32, 33], [32, 13],
  [33, 34], [33, 9],
  [34, 35], [34, 4],
  [35, 36], [35, 2],
  [36, 39], [36, 8],
  [37, 10], [37, 44],
  [38, 39], [38, 4],
  [39, 40], [39, 36],
  [40, 41], [40, 13],
  [41, 42], [41, 7],
  [42, 43], [42, 15],
  [43, 44], [43, 10],
  [44, 45], [44, 9],
  [45, 46], [45, 12],
  [46, 47], [46, 5],
  [0, 4], [0, 9], [1, 5], [2, 12], [3, 11],
  [6, 37], [7, 44], [8, 15], [9, 27], [10, 42],
];

function hashNoise(seed: number) {
  const x = Math.sin(seed * 12.9898) * 43758.5453;
  return x - Math.floor(x);
}

export default function IndiaMapHero() {
  const svgRef = useRef<SVGSVGElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const projRef = useRef<((lon: number, lat: number) => [number, number]) | null>(null);

  // Chargement du GeoJSON (inchangé)
  useEffect(() => {
    fetch("/shapes/india.geojson")
      .then((r) => {
        if (!r.ok) throw new Error(`india.geojson not found (status ${r.status})`);
        return r.json();
      })
      .then((data) => {
        const svg = svgRef.current;
        if (!svg) return;
        const W = svg.clientWidth || 700;
        const H = svg.clientHeight || 600;
        const coords: number[][][] = [];
        const geom = data.features[0].geometry;
        const polys = geom.type === "MultiPolygon" ? geom.coordinates : [geom.coordinates];
        polys.forEach((poly: any) =>
          poly.forEach((ring: any) => coords.push(ring))
        );
        let minLon = Infinity, maxLon = -Infinity, minLat = Infinity, maxLat = -Infinity;
        coords.forEach((ring) =>
          ring.forEach(([lon, lat]: number[]) => {
            minLon = Math.min(minLon, lon);
            maxLon = Math.max(maxLon, lon);
            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);
          })
        );
        const pad = 40;
        const scaleX = (W - pad * 2) / (maxLon - minLon);
        const scaleY = (H - pad * 2) / (maxLat - minLat);
        const scale = Math.min(scaleX, scaleY);
        const offX = pad + (W - pad * 2 - (maxLon - minLon) * scale) / 2;
        const offY = pad + (H - pad * 2 - (maxLat - minLat) * scale) / 2;
        const project = (lon: number, lat: number): [number, number] => [
          offX + (lon - minLon) * scale,
          H - (offY + (lat - minLat) * scale),
        ];
        projRef.current = project;
        const ns = "http://www.w3.org/2000/svg";
        svg.innerHTML = "";
        const defs = document.createElementNS(ns, "defs");

        const grad = document.createElementNS(ns, "linearGradient");
        grad.setAttribute("id", "ig");
        grad.setAttribute("x1", "0%");
        grad.setAttribute("y1", "0%");
        grad.setAttribute("x2", "100%");
        grad.setAttribute("y2", "100%");
        [
          ["0%", "#00e6c3", "0.35"],
          ["55%", "#009983", "0.16"],
          ["100%", "#041f24", "0.03"],
        ].forEach(([off, c, op]) => {
          const s = document.createElementNS(ns, "stop");
          s.setAttribute("offset", off);
          s.setAttribute("stop-color", c);
          s.setAttribute("stop-opacity", op);
          grad.appendChild(s);
        });

        const sg = document.createElementNS(ns, "linearGradient");
        sg.setAttribute("id", "sg");
        sg.setAttribute("x1", "0%");
        sg.setAttribute("y1", "0%");
        sg.setAttribute("x2", "100%");
        sg.setAttribute("y2", "100%");
        [
          ["0%", "#00ffcc", "1"],
          ["45%", "#009983", "0.9"],
          ["75%", "#ffd243", "0.55"],
          ["100%", "#eb280f", "0.35"],
        ].forEach(([off, c, op]) => {
          const s = document.createElementNS(ns, "stop");
          s.setAttribute("offset", off);
          s.setAttribute("stop-color", c);
          s.setAttribute("stop-opacity", op);
          sg.appendChild(s);
        });

        const glow = document.createElementNS(ns, "filter");
        glow.setAttribute("id", "glow");
        glow.setAttribute("x", "-50%");
        glow.setAttribute("y", "-50%");
        glow.setAttribute("width", "200%");
        glow.setAttribute("height", "200%");
        const blur = document.createElementNS(ns, "feGaussianBlur");
        blur.setAttribute("stdDeviation", "2.5");
        blur.setAttribute("result", "blur");
        const merge = document.createElementNS(ns, "feMerge");
        ["blur", "SourceGraphic"].forEach((i) => {
          const mn = document.createElementNS(ns, "feMergeNode");
          mn.setAttribute("in", i);
          merge.appendChild(mn);
        });
        glow.appendChild(blur);
        glow.appendChild(merge);

        defs.appendChild(grad);
        defs.appendChild(sg);
        defs.appendChild(glow);
        svg.appendChild(defs);

        coords.forEach((ring) => {
          const d =
            ring
              .map(([lon, lat]: number[], i: number) => {
                const [x, y] = project(lon, lat);
                return `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`;
              })
              .join(" ") + " Z";
          const path = document.createElementNS(ns, "path");
          path.setAttribute("d", d);
          path.setAttribute("fill", "url(#ig)");
          path.setAttribute("stroke", "url(#sg)");
          path.setAttribute("stroke-width", "1.6");
          path.setAttribute("filter", "url(#glow)");
          svg.appendChild(path);
        });
      })
      .catch((err) => {
        console.warn("IndiaMapHero: could not load india.geojson —", err.message);
      });
  }, []);

  // ============================================================
  // ANIMATION CANVAS – VERSION ORIGINALE LÉGÈRE
  // Seul ajout : avion à la place du point lumineux
  // ============================================================
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    let animId: number;
    let tick = 0;

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    // Icône avion (plus petite pour rester élégante)
    const planeImg = new Image();
    planeImg.src = "/photos/ATR-plane-icon.svg";
    let planeLoaded = false;
    planeImg.onload = () => { planeLoaded = true; };

    // Poussière d'étoiles (comme dans l'original)
    const dust = Array.from({ length: 60 }, (_, i) => ({
      xr: hashNoise(i * 3.1),
      yr: hashNoise(i * 7.7 + 1),
      r: 0.4 + hashNoise(i * 5.3 + 2) * 1.1,
      speed: 0.2 + hashNoise(i * 2.2 + 3) * 0.5,
      phase: hashNoise(i * 9.9 + 4) * Math.PI * 2,
    }));

    const ctrlPts: { cx: number; cy: number }[] = [];
    const getCtrl = (ai: number, bi: number, ri: number, W: number, H: number) => {
      if (ctrlPts[ri]) return ctrlPts[ri];
      const proj = projRef.current;
      if (!proj) return { cx: W / 2, cy: H / 2 };
      const [x1, y1] = proj(CITIES[ai][0], CITIES[ai][1]);
      const [x2, y2] = proj(CITIES[bi][0], CITIES[bi][1]);
      const dx = x2 - x1,
        dy = y2 - y1;
      const len = Math.sqrt(dx * dx + dy * dy);
      if (len < 1) return { cx: (x1 + x2) / 2, cy: (y1 + y2) / 2 };
      const side = ri % 2 === 0 ? 1 : -1;
      const curve = len * 0.82;
      const cx = (x1 + x2) / 2 - side * (dy / len) * curve;
      const cy = (y1 + y2) / 2 + side * (dx / len) * curve * 0.4;
      ctrlPts[ri] = { cx, cy };
      return ctrlPts[ri];
    };

    const bezierPt = (x1: number, y1: number, cx: number, cy: number, x2: number, y2: number, t: number) => ({
      x: (1 - t) * (1 - t) * x1 + 2 * (1 - t) * t * cx + t * t * x2,
      y: (1 - t) * (1 - t) * y1 + 2 * (1 - t) * t * cy + t * t * y2,
    });

    // Paramètres ralentis
    const DRAW = 3500;
    const HOLD = 2000;
    const FADE = 1400;
    const CYCLE = DRAW + HOLD + FADE;

    // On garde le même filtre que l'original (i % 2 === 0)
    const FEATURED = ROUTES.map((_, i) => i).filter((i) => i % 2 === 0);
    const flows = FEATURED.map((ri) => ({
      ri,
      offset: hashNoise(ri * 4.417) * CYCLE,
    }));

    const SAMPLES = 60;
    let startTime: number | null = null;

    const animate = (ts: number) => {
      if (startTime === null) startTime = ts;
      const elapsed = ts - startTime;
      const W = canvas.width,
        H = canvas.height;
      if (!projRef.current) {
        animId = requestAnimationFrame(animate);
        return;
      }
      ctx.clearRect(0, 0, W, H);
      tick += 1;

      // Poussière d'étoiles (identique à l'original)
      dust.forEach((d) => {
        const x = d.xr * W;
        const y = (d.yr * H + tick * 0.06 * d.speed) % H;
        const tw = Math.sin(tick * 0.02 + d.phase) * 0.5 + 0.5;
        ctx.beginPath();
        ctx.arc(x, y, d.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(0,230,195,${0.05 + tw * 0.1})`;
        ctx.fill();
      });

      const proj = projRef.current!;

      // Lignes statiques (identiques à l'original)
      ROUTES.forEach(([ai, bi], ri) => {
        const [x1, y1] = proj(CITIES[ai][0], CITIES[ai][1]);
        const [x2, y2] = proj(CITIES[bi][0], CITIES[bi][1]);
        const { cx, cy } = getCtrl(ai, bi, ri, W, H);
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.quadraticCurveTo(cx, cy, x2, y2);
        ctx.strokeStyle = "rgba(0,153,131,0.07)";
        ctx.lineWidth = 0.6;
        ctx.stroke();

        // Petite particule continue (identique)
        const particleT = (tick * (0.0018 + hashNoise(ri * 6.6) * 0.0012) +
          hashNoise(ri * 2.9)) % 1;
        const pp = bezierPt(x1, y1, cx, cy, x2, y2, particleT);
        ctx.beginPath();
        ctx.arc(pp.x, pp.y, 1, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(0,255,200,0.35)";
        ctx.fill();
      });

      // Arcs animés – version originale allégée
      flows.forEach(({ ri, offset }) => {
        const [ai, bi] = ROUTES[ri];
        const [x1, y1] = proj(CITIES[ai][0], CITIES[ai][1]);
        const [x2, y2] = proj(CITIES[bi][0], CITIES[bi][1]);
        const { cx, cy } = getCtrl(ai, bi, ri, W, H);

        const phase = (elapsed + offset) % CYCLE;
        let head: number, opacity: number;
        if (phase < DRAW) {
          head = phase / DRAW;
          opacity = 1;
        } else if (phase < DRAW + HOLD) {
          head = 1;
          opacity = 1;
        } else {
          head = 1;
          const fadeT = (phase - DRAW - HOLD) / FADE;
          opacity = 1 - fadeT;
        }
        if (head <= 0) return;

        const n = Math.max(1, Math.round(SAMPLES * head));
        const pts: { x: number; y: number; t: number }[] = [{ x: x1, y: y1, t: 0 }];
        for (let s = 1; s <= n; s++) {
          const tt = (s / n) * head;
          const p = bezierPt(x1, y1, cx, cy, x2, y2, tt);
          pts.push({ x: p.x, y: p.y, t: tt });
        }

        // Ombre (légère)
        ctx.beginPath();
        ctx.moveTo(pts[0].x, pts[0].y + 3);
        for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y + 3);
        ctx.strokeStyle = `rgba(0,0,0,${0.15 * opacity})`;
        ctx.lineWidth = 2.0;
        ctx.stroke();

        // Arc principal – style original (couleur unique avec dégradé de transparence)
        for (let i = 1; i < pts.length; i++) {
          const localT = pts[i].t;
          const taper = Math.sin(Math.PI * localT);
          ctx.beginPath();
          ctx.moveTo(pts[i - 1].x, pts[i - 1].y);
          ctx.lineTo(pts[i].x, pts[i].y);
          ctx.strokeStyle = `rgba(0,255,200,${(0.45 + taper * 0.4) * opacity})`;
          ctx.lineWidth = 0.9 + taper * 1.3;
          ctx.stroke();
        }
        ctx.shadowColor = "#00ffcc";
        ctx.shadowBlur = 5;
        ctx.beginPath();
        ctx.moveTo(pts[0].x, pts[0].y);
        for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
        ctx.strokeStyle = `rgba(0,255,200,${0.2 * opacity})`;
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.shadowBlur = 0;

        // Points de départ/arrivée
        const drawEndpoint = (px: number, py: number, a: number) => {
          ctx.beginPath();
          ctx.arc(px, py, 2.4, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255,210,67,${a})`;
          ctx.shadowColor = "#ffd243";
          ctx.shadowBlur = 8;
          ctx.fill();
          ctx.shadowBlur = 0;
        };
        drawEndpoint(x1, y1, 0.85 * opacity);
        if (head >= 1) {
          drawEndpoint(x2, y2, 0.85 * opacity);
        } else {
          // === ICI : AVION à la place du point lumineux ===
          const tip = bezierPt(x1, y1, cx, cy, x2, y2, head);
          const dx = 2 * (1 - head) * (cx - x1) + 2 * head * (x2 - cx);
          const dy = 2 * (1 - head) * (cy - y1) + 2 * head * (y2 - cy);
          const angle = Math.atan2(dy, dx);

          if (planeLoaded) {
            ctx.save();
            ctx.translate(tip.x, tip.y);
            ctx.rotate(angle - Math.PI / 2);
            ctx.globalAlpha = 0.8 * opacity;
            // Taille 18×18
            ctx.drawImage(planeImg, -9, -9, 18, 18);
            ctx.globalAlpha = 1;
            ctx.restore();
          } else {
            // Fallback : cercle lumineux
            ctx.beginPath();
            ctx.arc(tip.x, tip.y, 2.6, 0, Math.PI * 2);
            ctx.fillStyle = "#eaffff";
            ctx.shadowColor = "#00ffcc";
            ctx.shadowBlur = 10;
            ctx.fill();
            ctx.shadowBlur = 0;
          }
        }
      });

      // Villes (identiques à l'original)
      CITIES.forEach(([lon, lat], i) => {
        const [x, y] = proj(lon, lat);
        const pulse = Math.sin(tick * 0.02 + i * 0.7) * 0.5 + 0.5;
        const isHub = HUB_INDICES.has(i);
        const baseR = isHub ? 3.4 : 2.2;
        const ringR = isHub ? 13 + pulse * 6 : 8 + pulse * 4;
        const color = isHub ? "#ffd243" : "#009983";

        ctx.beginPath();
        ctx.arc(x, y, ringR, 0, Math.PI * 2);
        ctx.strokeStyle = isHub
          ? `rgba(255,210,67,${0.05 + pulse * 0.1})`
          : `rgba(0,153,131,${0.04 + pulse * 0.07})`;
        ctx.lineWidth = isHub ? 1.4 : 1;
        ctx.stroke();

        if (isHub) {
          ctx.beginPath();
          ctx.arc(x, y, ringR * 0.6, 0, Math.PI * 2);
          ctx.strokeStyle = `rgba(255,210,67,${0.08 + pulse * 0.12})`;
          ctx.lineWidth = 1;
          ctx.stroke();
        }

        ctx.beginPath();
        ctx.arc(x, y, baseR, 0, Math.PI * 2);
        ctx.fillStyle = color;
        ctx.shadowColor = isHub ? "#ffd243" : "#00ffcc";
        ctx.shadowBlur = isHub ? 16 : 12;
        ctx.fill();
        ctx.shadowBlur = 0;

        ctx.beginPath();
        ctx.arc(x, y, baseR * 0.35, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255,0.85)";
        ctx.fill();
      });

      animId = requestAnimationFrame(animate);
    };

    animId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        marginRight: "auto", 
        marginTop: "3%",
      }}
    >
      <svg
        ref={svgRef}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
        }}
      />
      <canvas
        ref={canvasRef}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}